(function () {
  'use strict';

  const ttl = 15 * 60 * 1000;
  const requestTimeout = 12000;
  const fieldMap = [
    ['contact[Name]', 'firstname'],
    ['contact[Business Name]', 'company'],
    ['contact[State]', 'state'],
    ['contact[Phone]', 'phone'],
    ['contact[email]', 'email']
  ];

  function trackAcceptedInquiry(section, form, storage, key, pending, returnedAttempt, nativeResult) {
    const destination = (section.dataset.googleAdsDestination || '').trim();
    if (!/^AW-\d+\/[\w-]+$/.test(destination)) return;
    const adsKey = key + ':googleAds:' + destination;
    const navigation = window.performance && window.performance.getEntriesByType('navigation')[0];
    let timer;
    let stopped = false;
    let privacyLoading = false;
    const setStatus = function (value) { section.dataset.gfGoogleAdsStatus = value; };

    function readAds() {
      try {
        const raw = storage.getItem(adsKey);
        if (!raw) return null;
        const record = JSON.parse(raw);
        if (!record || record.version !== 1 || !/^[\da-f-]{36}$/i.test(record.attemptId || '') || !Number.isFinite(record.expiresAt) || record.expiresAt <= Date.now() || !['waiting', 'claimed'].includes(record.status)) {
          storage.removeItem(adsKey);
          return null;
        }
        return record;
      } catch (_) {
        try { storage.removeItem(adsKey); } catch (_) {}
        return null;
      }
    }

    function writeAds(record) {
      try {
        const serialized = JSON.stringify(record);
        storage.setItem(adsKey, serialized);
        return storage.getItem(adsKey) === serialized;
      } catch (_) {
        return false;
      }
    }

    let record = readAds();
    if (!nativeResult || nativeResult.dataset.gfLeadResult !== 'accepted' || (navigation && navigation.type === 'back_forward')) return;
    if (pending && pending.attemptId === returnedAttempt && /^[\da-f-]{36}$/i.test(pending.attemptId || '')) {
      if (!record || record.attemptId !== pending.attemptId) {
        record = { version: 1, attemptId: pending.attemptId, expiresAt: pending.expiresAt, status: 'waiting' };
        if (!writeAds(record)) { setStatus('unavailable'); return; }
      }
    } else if (!record || (returnedAttempt && returnedAttempt !== record.attemptId) || (pending && pending.attemptId !== record.attemptId)) {
      return;
    }

    function stop() {
      stopped = true;
      window.clearTimeout(timer);
      document.removeEventListener('visitorConsentCollected', attempt);
    }

    function retry() {
      window.clearTimeout(timer);
      timer = window.setTimeout(attempt, Math.min(1000, Math.max(1, record.expiresAt - Date.now())));
    }

    function ensurePrivacyApi() {
      const shopify = window.Shopify;
      if (shopify && shopify.customerPrivacy) return true;
      if (!shopify || typeof shopify.loadFeatures !== 'function') {
        setStatus('waiting-privacy-api');
        retry();
        return false;
      }
      if (privacyLoading) return false;
      privacyLoading = true;
      setStatus('loading-privacy-api');
      try {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
          privacyLoading = false;
          if (stopped) return;
          if (error) {
            setStatus('privacy-api-error');
            retry();
            return;
          }
          attempt();
        });
      } catch (_) {
        privacyLoading = false;
        setStatus('privacy-api-error');
        retry();
      }
      return false;
    }

    function attempt() {
      if (stopped) return;
      window.clearTimeout(timer);
      const current = readAds();
      if (!current || current.attemptId !== record.attemptId) { setStatus('expired'); stop(); return; }
      if (current.status === 'claimed') { setStatus('already-queued'); stop(); return; }
      if (!ensurePrivacyApi()) return;
      let allowed = false;
      try {
        const privacy = window.Shopify && window.Shopify.customerPrivacy;
        allowed = !!privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === true;
      } catch (_) {}
      if (!allowed) { setStatus('waiting-consent'); retry(); return; }
      if (typeof window.gtag !== 'function') { setStatus('waiting-tag'); retry(); return; }
      if (!writeAds({ version: 1, attemptId: current.attemptId, expiresAt: current.expiresAt, status: 'claimed' })) {
        setStatus('unavailable'); stop(); return;
      }
      try {
        window.gtag('event', 'conversion', { send_to: destination, transaction_id: current.attemptId });
        setStatus('queued');
      } catch (_) {
        setStatus('unknown');
      }
      stop();
    }

    document.addEventListener('visitorConsentCollected', attempt);
    form.addEventListener('submit', stop, true);
    attempt();
  }

  function init(section) {
    const form = section.querySelector('.gf-corp-lead-form__form');
    if (!form || form.dataset.gfLeadBound) return;
    form.dataset.gfLeadBound = 'true';

    section.querySelectorAll('[data-gf-lead-select]').forEach(function (select) {
      const sync = function () { select.classList.toggle('is-filled', !!select.value); };
      select.addEventListener('change', sync);
      sync();
    });

    if (section.dataset.hubspotEnabled !== 'true' || (window.Shopify && window.Shopify.designMode)) return;
    const portal = section.dataset.hubspotPortal || '';
    const formId = section.dataset.hubspotForm || '';
    if (!/^\d+$/.test(portal) || !/^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i.test(formId)) return;

    const key = ['gfCorporateInquiry', 'v1', portal, formId, form.id, window.location.pathname].join(':');
    const endpoint = 'https://api.hsforms.com/submissions/v3/integration/submit/' + portal + '/' + formId;
    const nativeResult = form.querySelector('[data-gf-lead-result]');
    const pageUrl = new URL(window.location.href);
    let returnedAttempt = pageUrl.searchParams.get('gf_inquiry');
    if (!pageUrl.searchParams.has('gf_inquiry') && document.referrer) {
      try {
        const referrer = new URL(document.referrer);
        if (referrer.origin === pageUrl.origin && referrer.pathname === pageUrl.pathname) {
          returnedAttempt = referrer.searchParams.get('gf_inquiry');
        }
      } catch (_) {}
    }
    let storage;

    function status(value) {
      section.dataset.gfHubspotStatus = value;
    }

    function read() {
      try {
        const raw = storage.getItem(key);
        if (!raw) return null;
        const record = JSON.parse(raw);
        if (!record || record.version !== 1 || !Number.isFinite(record.expiresAt) || record.expiresAt <= Date.now()) {
          storage.removeItem(key);
          return null;
        }
        return record;
      } catch (_) {
        try { storage.removeItem(key); } catch (_) {}
        return null;
      }
    }

    function write(record) {
      try {
        const value = JSON.stringify(record);
        storage.setItem(key, value);
        return storage.getItem(key) === value;
      } catch (_) {
        return false;
      }
    }

    function receipt(record, outcome) {
      return { version: 1, attemptId: record.attemptId, createdAt: record.createdAt, expiresAt: record.expiresAt, status: outcome };
    }

    try {
      storage = window.sessionStorage;
      const probe = key + ':available';
      storage.setItem(probe, '1');
      storage.removeItem(probe);
    } catch (_) {
      status('unavailable');
      return;
    }

    function expire(record) {
      if (record) window.setTimeout(function () { read(); }, Math.max(0, record.expiresAt - Date.now()) + 1);
    }

    function finish(record, outcome) {
      const current = read();
      if (current && current.attemptId === record.attemptId) {
        write(receipt(record, outcome));
        status(outcome);
      }
    }

    status('ready');
    const pending = read();
    expire(pending);
    trackAcceptedInquiry(section, form, storage, key, pending, returnedAttempt, nativeResult);

    if (nativeResult && nativeResult.dataset.gfLeadResult === 'rejected') {
      try { storage.removeItem(key); } catch (_) {}
      status('shopify-rejected');
    } else if (nativeResult && nativeResult.dataset.gfLeadResult === 'accepted') {
      const navigation = window.performance && window.performance.getEntriesByType('navigation')[0];
      if (navigation && navigation.type === 'back_forward') {
        status('history-return');
      } else if (pending && pending.status === 'pending' && pending.attemptId === returnedAttempt && Array.isArray(pending.fields)) {
        const payload = JSON.stringify({ fields: pending.fields, context: pending.context });
        const attempted = receipt(pending, 'unknown');
        if (write(attempted)) {
          status('sending');
          const controller = new AbortController();
          const timeout = window.setTimeout(function () { controller.abort(); }, requestTimeout);
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'omit',
            keepalive: new TextEncoder().encode(payload).byteLength <= 60000,
            signal: controller.signal,
            body: payload
          }).then(function (response) {
            const outcome = response.ok ? 'accepted' : (response.status >= 500 ? 'unknown' : 'rejected');
            finish(pending, outcome);
          }).catch(function () {
            finish(pending, 'unknown');
          }).finally(function () {
            window.clearTimeout(timeout);
          });
        } else {
          try { storage.removeItem(key); } catch (_) {}
          status('unavailable');
        }
      } else {
        status(pending && pending.status === 'pending' ? 'attempt-mismatch' : (pending ? pending.status : 'no-pending-inquiry'));
      }
    }

    form.addEventListener('submit', function (event) {
      form.querySelectorAll('input[required]').forEach(function (input) {
        if (input.type === 'text' || input.type === 'email') input.value = input.value.trim();
      });
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        form.reportValidity();
        return;
      }
      const data = new FormData(form);
      const fields = fieldMap.map(function (mapping) {
        return { objectTypeId: '0-1', name: mapping[1], value: String(data.get(mapping[0]) || '').trim() };
      }).filter(function (field) { return field.value !== ''; });
      const message = String(data.get('contact[body]') || '').trim();
      const source = String(data.get('contact[Source]') || '').trim();
      const terms = data.get('contact[Agreed to terms]') === 'Yes' ? 'Selected' : 'Not selected';
      const quantity = String(data.get('contact[Approximate Quantity]') || '').trim();
      const deliveryDate = String(data.get('contact[Desired Delivery Date]') || '').trim();
      const tracking = new URL(window.location.href);
      const trackingLabels = {
        utm_source: 'UTM source',
        utm_medium: 'UTM medium',
        utm_campaign: 'UTM campaign',
        utm_term: 'UTM term',
        utm_content: 'UTM content',
        gclid: 'Google click ID'
      };
      const trackingLines = Object.keys(trackingLabels).map(function (key) {
        const value = String(tracking.searchParams.get(key) || '').trim();
        return value ? trackingLabels[key] + ': ' + value : '';
      }).filter(Boolean);
      fields.push({
        objectTypeId: '0-1',
        name: 'message',
        value: [
          message,
          quantity ? 'Approximate quantity: ' + quantity : '',
          deliveryDate ? 'Desired delivery date: ' + deliveryDate : '',
          source ? 'Inquiry source: ' + source : '',
          trackingLines.join('\n'),
          'Terms checkbox: ' + terms
        ].filter(Boolean).join('\n\n')
      });
      if (!window.history || typeof window.history.replaceState !== 'function' || !window.crypto || typeof window.crypto.randomUUID !== 'function') {
        try { storage.removeItem(key); } catch (_) {}
        status('unavailable');
        return;
      }
      const attemptId = window.crypto.randomUUID();
      const destination = new URL(window.location.href);
      destination.searchParams.delete('contact_posted');
      destination.searchParams.delete('form_type');
      destination.searchParams.delete('form_error');
      destination.searchParams.set('gf_inquiry', attemptId);
      const theme = window.Shopify && window.Shopify.theme;
      if (theme && theme.role === 'unpublished' && /^\d+$/.test(String(theme.id)) && !destination.searchParams.has('preview_theme_id')) {
        destination.searchParams.set('preview_theme_id', String(theme.id));
      }
      if (!destination.hash) destination.hash = form.id;
      const now = Date.now();
      const record = {
        version: 1,
        attemptId: attemptId,
        status: 'pending',
        createdAt: now,
        expiresAt: now + ttl,
        fields: fields,
        context: {
          pageUri: window.location.origin + window.location.pathname,
          pageName: document.title
        }
      };
      if (write(record)) {
        try {
          window.history.replaceState(window.history.state, '', destination.pathname + destination.search + destination.hash);
          status('pending');
          expire(record);
        } catch (_) {
          try { storage.removeItem(key); } catch (_) {}
          status('unavailable');
        }
      } else {
        try { storage.removeItem(key); } catch (_) {}
        status('unavailable');
      }
    }, true);
  }

  document.querySelectorAll('[data-gf="corp-lead-form"]').forEach(init);
})();
